// utils/copyToClipboard.js
export const copyToClipboard = async (text, onCopyCallback) => {
    if (!text) {
      return;
    }
  
   try {
    await navigator.clipboard.writeText(text);

    if (onCopyCallback) {
      onCopyCallback(`${text} Copied`);
    }

    return true; // ✅ success
  } catch (err) {
    console.error("Failed to copy text to clipboard:", err);
    return false; // ❌ failed
  }
  };
  